import React from 'react';
import { Link } from "gatsby"

const ServicesCard = () => {
    return (
        <div className="services-area bg-f9f9f9 pt-100 pb-70">
            <div className="container">
                <div className="section-title">
                    <span className="sub-title">Harness the Power of AI</span>
                    <h2>Featured Services</h2>
                    <p>We help our clients harness the power of artificial intelligence to drive growth, enhance productivity, improve efficiency and scale operations.</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                    <Link to="/vision-artifical-intelligence-services">
                        <div className="single-services-box">
                            <div className="icon">
                            <i className="bx bx-show-alt"></i>
                                <div className="circles-box">
                                    <div className="circle-one"></div>
                                    <div className="circle-two"></div>
                                </div>
                            </div>
                            <h3>
                                <Link to="/vision-artifical-intelligence-services">
                                    Vision AI
                                </Link>
                            </h3>
                            <p>Build AI products capable of holistic human detection, dynamic object detection, text detection & much more.</p>

                            <Link to="/vision-artifical-intelligence-services/" className="learn-more-btn">
                                <i className="left-icon flaticon-next-button"></i> 
                                Learn More 
                                <i className="right-icon flaticon-next-button"></i>
                            </Link>
                        </div>
                    </Link>    
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                    <Link to="/ai-in-conversations">
                        <div className="single-services-box">
                            <div className="icon">
                                <i className="bx bx-conversation"></i>
                                <div className="circles-box">
                                    <div className="circle-one"></div>
                                    <div className="circle-two"></div>
                                </div>
                            </div>
                            <h3>
                                <Link to="/ai-in-conversations">
                                    Conversational AI
                                </Link>
                            </h3>
                            <p>Start your CX automation journey with the help of AI powered language engines and deploy bots for voice and chat.</p>
                            
                            <Link to="/ai-in-conversations" className="learn-more-btn">
                                <i className="left-icon flaticon-next-button"></i> 
                                Learn More 
                                <i className="right-icon flaticon-next-button"></i>
                            </Link>
                        </div>
                        </Link>
                   
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                    <Link to="/natural-language-nlp-services">
                        <div className="single-services-box">
                            <div className="icon">
                                <i className="bx bx-notepad"></i>
                                <div className="circles-box">
                                    <div className="circle-one"></div>
                                    <div className="circle-two"></div>
                                </div>
                            </div>
                            <h3>
                                <Link to="/natural-language-nlp-services">
                                    Natural Language AI
                                </Link>
                            </h3>
                            <p>Design AI products that process data from structured and unstructured sources to identify patterns and generate predictive insights.</p>
                            
                            <Link to="/natural-language-nlp-services" className="learn-more-btn">
                                <i className="left-icon flaticon-next-button"></i> 
                                Learn More 
                                <i className="right-icon flaticon-next-button"></i>
                            </Link>
                        </div>
                    </Link>    
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                    <Link to="/predictive-artificial-intelligence-services">
                        <div className="single-services-box">
                            <div className="icon">
                                <i className="bx bx-search-alt"></i>
                                <div className="circles-box">
                                    <div className="circle-one"></div>
                                    <div className="circle-two"></div>
                                </div>
                            </div>
                            <h3>
                                <Link to="/predictive-artificial-intelligence-services">
                                   Predictive AI
                                </Link>
                            </h3>
                            <p>Use machine learning to assess historical data, discover patterns, observe trends, and use that information to drive growth.</p>
                            
                            <Link to="/predictive-artificial-intelligence-services" className="learn-more-btn">
                                <i className="left-icon flaticon-next-button"></i> 
                                Learn More 
                                <i className="right-icon flaticon-next-button"></i>
                            </Link>
                        </div>
                    </Link>    
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-6">
                    <Link to="/ai-ml-app-development-services"> 
                        <div className="single-services-box">
                            <div className="icon">
                                <i className="bx bx-devices"></i>
                                <div className="circles-box">
                                    <div className="circle-one"></div>
                                    <div className="circle-two"></div>
                                </div>
                            </div>
                            <h3>
                                <Link to="/ai-ml-app-development-services">
                                   AI/ML App Development
                                </Link>
                            </h3>
                            <p>Design, develop and deploy smart applications that deliver a seamless experience for users across web and mobile platforms.</p>
                            
                            <Link to="/ai-ml-app-development-services" className="learn-more-btn">
                                <i className="left-icon flaticon-next-button"></i> 
                                Learn More 
                                <i className="right-icon flaticon-next-button"></i>
                            </Link>
                        </div>
                    </Link>    
                    </div>

                    
                </div>
            </div>
        </div>
    )
}

export default ServicesCard;